
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import AppButton from '@/components/AppButton.vue';

@Component({
	components: {
		AppButton
	}
})
export default class ChapterIntro extends Vue {
	private show: boolean = true;

	private get domainLabel(): string {
		return this.$store.state.currentDomain.label;
	}

	private get chapterLabel(): string {
		return this.$store.state.currentChapter.label;
	}

	private start(): void {
		this.show = false;
	}
}
